// Take an einen Block anhängen — pure Variante von `useSessionStore.appendTake`
// (Cap auf MAX_TAKES_PER_BLOCK: ältester Nicht-Favorit fällt raus, favIdx
// wandert mit). Ausgelagert, damit TTSView nach dem `await` über den
// festgehaltenen Asset-Index schreiben kann statt über „das aktuelle Asset"
// (Audit M17: Asset-Wechsel während des Requests/Decodes ließ die Dauer bei 0
// bzw. hängte den Take ans falsche Asset). Spiegel von legacy
// generateTTSBlock.

import type { Block, Take } from '@shared/types';
import { MAX_TAKES_PER_BLOCK } from '@shared/constants';

/** Hängt `take` an `blocks[blockIdx]` an und bumpt `takeCounter`. Gibt das
 *  Eingabe-Array zurück, wenn der Block nicht existiert. */
export function appendTakeToBlocks(blocks: Block[], blockIdx: number, take: Take): Block[] {
  const target = blocks[blockIdx];
  if (!target) return blocks;
  const takes = target.takes.slice();
  let favIdx = target.favIdx;
  if (takes.length >= MAX_TAKES_PER_BLOCK) {
    let removeIdx = takes.findIndex((_, i) => i !== favIdx);
    if (removeIdx === -1) removeIdx = 0;
    takes.splice(removeIdx, 1);
    if (favIdx === removeIdx) favIdx = -1;
    else if (favIdx > removeIdx) favIdx--;
  }
  takes.push(take);
  // Kein Auto-Favorit — der Stern ist eine bewusste Entscheidung (Vanilla).
  const next = blocks.slice();
  next[blockIdx] = { ...target, takes, favIdx, takeCounter: target.takeCounter + 1 };
  return next;
}

/** Trägt die decodierte Dauer eines Takes nach — gesucht über die stabile
 *  Take-ID, weil zwischen Append und Decode ein Reorder liegen kann. Liefert
 *  zusätzlich den Block-Index, damit der Aufrufer bei einem Favoriten die
 *  Auto-Position anstoßen kann. Eingabe unverändert, wenn der Take fehlt. */
export function patchTakeDuration(
  blocks: Block[],
  takeId: string,
  duration: number,
): { blocks: Block[]; blockIdx: number; wasFav: boolean } {
  const bi = blocks.findIndex((b) => b.takes.some((t) => t.id === takeId));
  if (bi === -1) return { blocks, blockIdx: -1, wasFav: false };
  const target = blocks[bi];
  const ti = target.takes.findIndex((t) => t.id === takeId);
  const takes = target.takes.slice();
  takes[ti] = { ...takes[ti], duration };
  const next = blocks.slice();
  next[bi] = { ...target, takes };
  return { blocks: next, blockIdx: bi, wasFav: target.favIdx === ti };
}
